module.exports = __webpack_public_path__ + "img/cattunnel03.9f4e53cb.jpg";